import { gql }  from '@apollo/client';

const HEALTH_SIGNALS = gql`
  query ($id: ID!){
    member(id: $id){
      healthSignals
    }
  }
`;

export default HEALTH_SIGNALS;
